import React from 'react';

import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { MetaDataItemSkeletonWide } from '../../../../../../../common/ui/search-result-skeleton';

import { messages } from './messages';

interface OwnerNameProps {
	displayName?: string | null;
	isLoading?: boolean;
}

export const CompassOwnerName = ({
	displayName,
	isLoading = false,
}: OwnerNameProps): React.JSX.Element | undefined => {
	if (displayName) {
		return (
			<Box xcss={owningTeamStyles}>
				<FormattedMessage {...messages.ownerName} values={{ ownerName: displayName }} />
			</Box>
		);
	}

	if (isLoading) {
		return <MetaDataItemSkeletonWide />;
	}
};

const owningTeamStyles = xcss({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	maxWidth: '200px',
});
